import { BaseRestService } from "./BaseRestService";
import { API_URL_V3 } from "./constants/api";

export const restServiceV3 = new BaseRestService(API_URL_V3);
